import * as styled from '../../../util/styled'

type MainContentProps = {
  children: React.ReactNode
  legacyStyling: boolean
}

export const MainContentView = (props: MainContentProps) => {
  const { children, legacyStyling } = props

  return (
    <div className={styled.cx('v2-main-content', {'tailwind-scope': !legacyStyling, 'legacy-styling': legacyStyling })}>
      {children}
    </div>
  )
}